import React, {ComponentType, ReactNode} from 'react';

// styles
import {
  CardGreyBorderWrapper,
  CardPrimaryBorderWrapper,
  CardWhiteBorderWrapper,
} from './CardBorder-styles';

// types
type Variant = 'primary' | 'white' | 'grey';

type Props = {
  children: ReactNode;
  variant: Variant;
  hasShadow?: boolean;
  hasHoverEffect?: boolean;
};

type WrapperMap = {
  [key in Variant]: ComponentType<{
    children: ReactNode;
    hasShadow: boolean;
    hasHoverEffect: boolean;
  }>;
};

const wrapperMap: WrapperMap = {
  primary: CardPrimaryBorderWrapper,
  white: CardWhiteBorderWrapper,
  grey: CardGreyBorderWrapper,
};

const defaultHoverEffect: Record<Variant, boolean> = {
  primary: true,
  white: false,
  grey: false,
};

const CardBorder = ({
  children,
  variant,
  hasHoverEffect,
  hasShadow = false,
}: Props) => {
  // Get the default value for hover effect based on the variant
  const resolvedHoverEffect = hasHoverEffect ?? defaultHoverEffect[variant];
  const Wrapper = wrapperMap[variant];

  return (
    <Wrapper hasShadow={hasShadow} hasHoverEffect={resolvedHoverEffect}>
      {children}
    </Wrapper>
  );
};

export default CardBorder;
